import React from 'react';
import Alert, { AlertProps } from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';

import { isDLError } from '../../errors';
import useSelector from '../../hooks/useSelector';

const AlertBar: React.FC = () => {
  const { t, i18n } = useTranslation();
  const alert = useSelector(state => state.alert);

  const renderAlert = (
    type: AlertProps['variant'],
    message: string
  ): React.ReactElement => (
    <Container>
      <br />
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <Alert variant={type}>{t(message)}</Alert>
        </Col>
      </Row>
    </Container>
  );

  switch (alert?.type) {
    case 'error': {
      return renderAlert(
        'danger',
        isDLError(alert.error)
          ? alert.error.getMessage(i18n.language)
          : typeof alert.error === 'string'
            ? alert.error
            : alert.error.message
      );
    }
    case 'success-message': {
      return renderAlert('success', alert.message);
    }
    default: {
      return null;
    }
  }
};

export default AlertBar;
